// ============================================================================
// 引用气泡的发送者标签 —— 纯函数层。
//
// 单独成文件的原因和 home-logic.js 一样:message-area.js 是 JSX,node 的测试
// runner 直接 import 会 SyntaxError。`t` 由调用方注入(与
// resolveEmptyStateIdentity 同形),这一层就不依赖 i18n 的加载时序,可直接测。
// ============================================================================

/**
 * 引用气泡上"这条引用是谁说的"那行标签。
 *
 * 此前两处渲染点都是
 *   `reply_to.from_user === 'visitor' ? conf.visitorPronoun : conf.agentName`
 * 而 `visitorPronoun` 在 default-configuration.js 里写死成中文「您」（唯一来源、
 * 无任何 i18n 分支），`agentName` **压根没有定义** —— 全仓零命中，服务端也不发，
 * React 把 undefined 渲染成空。于是：任何语言的访客引用自己的消息都印着「您」，
 * 引用客服消息时那一格是空的。
 *
 * 改走 i18n（键与 Android 的 ReplyRenderer 回落链同名：chat.reply_self /
 * chat.reply_agent），商户配置仍然优先——留着那条路是因为 dash 将来若真提供
 * 「访客称谓」配置项，这里不用再改一次。
 */
export function replyFromLabel(fromUser, conf, t) {
    const isVisitor = fromUser === 'visitor';
    const configured = isVisitor ? conf && conf.visitorPronoun : conf && conf.agentName;
    if (typeof configured === 'string' && configured.trim() !== '') return configured;
    return t(isVisitor ? 'chat.reply_self' : 'chat.reply_agent');
}
